<template>
  <div>
    <v-dialog v-model="questionamentoDialog" scrollable max-width="700">
      <base-modal>
        <h2 class="title">Questionamento</h2>
        <div class="box-form">
          <v-textarea
            no-resize
            class="jns-input"
            v-model="observacao"
            placeholder=" "
            label="Observação"
          ></v-textarea>

          <documento-upload
            v-if="mostraCampoUpload"
            @select="handleSelectedFile"
            class="anexo-list"
          ></documento-upload>

          <div class="box-button">
            <button class="button jns-button yellow-button" @click="enviar()">
              Enviar
            </button>
          </div>
        </div>
      </base-modal>
    </v-dialog>

    <v-dialog v-model="questionamentoSucessoDialog" max-width="640px">
      <base-modal>
        <h3>Questionamento realizado com sucesso!</h3>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8 pb-0>
            <v-btn
              class="button jns-button yellow-button mt-4"
              @click="fecharModal()"
              >OK</v-btn
            >
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
export default {
  name: "QuestionamentoComponent",
  data() {
    return {
      observacao: "",
      showTooTip: false,
      dados: [],
      documentos: null,
    };
  },
  props: {
    questionamentoDialog: {
      type: Boolean,
      default: false,
    },
    questionamentoSucessoDialog: {
      type: Boolean,
      default: false,
    },
    mostraCampoUpload: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    handleSelectedFile(data){
      this.documentos = data;
    },

    // Emite para o componente pai os valores da observação e documentos
    // mostraCampoUpload validação para a apresentação do campo
    enviar() {
      if(this.documentos != null) {
        this.$emit("send", {observacao: this.observacao, documentos: [this.documentos]});
      } else {
        this.$emit("send", this.observacao);
      }
    },
    fecharModal() {
      window.location.reload();
    }
  },
  watch: {
    questionamentoDialog: function (value) {
      if (!value) this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  height: 42px;
  display: inline-block;
}
#jns {
  .box-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 2rem;

    .jns-input {
      width: 100%;
    }
    .anexo-list {
      padding: 0 !important;
      margin: 0 0 2rem 2px;
    }

    .box-button {
      width: 100%;
      display: flex;
      justify-content: flex-end;

      .jns-button {
        width: 30%;
      }
    }

    @media screen and (max-width: 350px) {
      .box-button {
        .jns-button {
          width: 100%;
        }
      }
    }
  }

  .msg__container {
    width: 30%;
    background-color: #fff;
    position: absolute;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    right: 30px;
    top: 0px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;

      &.info-red {
        margin-bottom: 5px;
      }
    }
  }

  .info-red {
    color: #d21a5e;
  }

  .custom-i {
    font-size: 18px;
    cursor: pointer;
  }

  .box_group {
    border-radius: 10px;
    border: 1px solid;
    padding: 10px;
    border-color: lightgray;
    margin: 0px;
    margin-bottom: 10px;
  }

  .tooltip_icon {
    cursor: help;
  }
  .document_name {
    max-width: 315px;
    height: 50px;
    padding-left: 8px;
    margin-bottom: 10px;
  }
  .pad {
    margin-top: -22px;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/QuestionamentoComponent.vue